

import { useState,useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const AddLabGroup = () => {
    const {university_name,dean_name,department_name,lab_name}=useParams()
    const navigate=useNavigate()
    const [users, setUsers] = useState([]); // ✅ initialize as array
    const [loading,setLoading]=useState(false)
    const [group_name,setGroupName]=useState("")
    const [group_description,setGroupDescription]=useState("")
    const [logo,setLogo]=useState("")
     useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/marketplace/university/user-profiles/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              "x-api-key": process.env.REACT_APP_X_API_KEY,
            },
          }
        );

        // console.log("Users API Response:", res.data);

        // ✅ handle paginated OR normal response
        setUsers(res.data.results || res.data || []);
      } catch (error) {
        console.log("Error while getting profiles", error);
        setUsers([]);
      }
    };

    fetchUsers();
  }, []);
   
  const options = users.map((user) => ({
    value: user.profile_id || user.id,
    label: `${user.name || user.full_name} (${user.email})`
  }));

 


const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true)
  try {
    const formData = new FormData();
    formData.append("group_name", group_name);
    formData.append("description", group_description);
    formData.append("group_logo", logo); 

    const response = await axios.post(
       `${BASE_URL}/marketplace/university/labhead/group/`,
      formData,
      {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
      }
    );
    if(response.status === 201)
    {
         alert('Lab group created successfully')
         navigate( `/marketplace/${university_name}/${dean_name}/${department_name}/${lab_name}/labhead/lab_groups`)
    }
    // console.log("Success:", response.data);
  } catch (error) {
    console.error("Error:", error.response?.data || error.message);
  } finally{
    setLoading(false)
  }
};
  return (
    <div className="max-w-5xl mx-auto">
    <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
       {/* Header */}
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Add Group</h1>
      </div>
      <p className="text-gray-500 text-sm">
        Fill in the details below to add a new group with members to your organization.
      </p>
    </div>
     {/* Form */}
    <form className="space-y-6" onSubmit={handleSubmit}>
    {/* Department Name */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-semibold text-gray-700">Group Name</label>
        </div>
        <input
          type="text"
          value={group_name}
          onChange={(e) => setGroupName(e.target.value)}
          placeholder="e.g. Computer Science, Mathematics, Physics"
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          required
        />
        <p className="text-xs text-gray-500 mt-2">Enter the full name of the department</p>
      </div>
      {/* Head of Department */}
    <div>
  <div className="flex items-center gap-2 mb-3">
    <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
    <label className="text-sm font-semibold text-gray-700">Group Description</label>
  </div>
  <textarea
    value={group_description}
    onChange={(e)=>setGroupDescription(e.target.value)}
    placeholder="e.g. This group focuses on advanced computer science topics, research projects, and collaborative learning."
    className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all resize-none"
    rows={4}
    required
  ></textarea>
  <p className="text-xs text-gray-500 mt-2">Enter a detailed description of the group</p>
</div>
     <div className="space-y-4">
        <div className="flex items-center gap-2">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <h3 className="text-sm font-semibold text-gray-700">Group Logo</h3>
        </div>

        {logo ? (
          <div className="relative border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-[#0f6abf] transition-colors">
            <div className="flex flex-col items-center">
              <img 
                src={URL.createObjectURL(logo)} 
                alt="Logo preview" 
                className="w-20 h-20 object-cover rounded-lg mb-3"
              />
              <p className="text-sm text-gray-600">Click to change logo</p>
              <p className="text-xs text-gray-500 mt-1">PNG, JPG, GIF up to 5MB</p>
            </div>
            <input
              type="file"
              name="logo"
              onChange={(e) => setLogo(e.target.files[0])}
              accept="image/*"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            />
          </div>
        ) : (
          <div className="relative border-2 border-dashed border-gray-300 rounded-xl p-8 text-center hover:border-[#0f6abf] transition-colors">
            <input
              type="file"
              name="logo"
              onChange={(e) => setLogo(e.target.files[0])}
              accept="image/*"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            />
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <p className="text-sm text-gray-600 font-medium">Click to upload logo</p>
              <p className="text-xs text-gray-500 mt-1">PNG, JPG, GIF up to 5MB</p>
            </div>
          </div>
        )}
      </div>
 
      <button
        type="submit"
        className="mt-4 w-full bg-[#0f6abf] text-white py-3 rounded-xl font-medium hover:bg-[#0a5ca8] transition-all disabled:opacity-50 flex items-center justify-center gap-2"
      >
        {loading ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            <span>Creating Group...</span>
          </>
        ) : (
          <>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Create New Group
          </>
        )}
      </button>
    </form>
    </div>
    </div>
  )
}

export default AddLabGroup
